import React, { Component } from 'react';
import { connect } from 'react-redux';
import AceSelector from "./AceSelector";
import { fetch_alerts, select_dando,send_email } from "../redux/actions";
import Paginator from "../../hoc/Paginator/Paginator";
import Modal from "react-responsive-modal";
import { FaTimes } from "react-icons/fa";
import Disclosure from "../Disclosure";
import styled from "styled-components";
import { Button } from "../../common/components/Button";
const ButtonHolder = styled.div`
	margin-top: 10px;
`;
const LeftSideButton = styled(Button)`
	float: right;
`;
class AceSelectorContainer extends Component {

	state = {
		searchText: '',
		sortText: '',
		sortOrderType: '',
		openBlock:false
	}

	componentDidMount() {
		this.fetchAceAlerts();
		localStorage.removeItem('searchValue');
		localStorage.removeItem('sortParams');
	}

	onAceAlertSelect = (alert) => {
		if (alert.alertId !== null) {
			sessionStorage.setItem('AceAlerts',true);
			this.props.history.push("/cases/" + (parseInt(alert.alertId, 10)));

		} else {
			this.props.history.push("/cases/0");
		}
	};
	onCloseBlockModal = () => {
		this.setState({ openBlock: false });
	}

	handleSearch = (searchText) => {
		this.setState({ searchText }, () => {
			this.fetchAceAlerts();
		});
	}

	handleSort = (sortText, sortOrderType) => {
		this.setState({ sortText, sortOrderType }, () => {
			this.fetchAceAlerts();
		});
	}

	handleClear = () =>{
		this.setState({searchText: '', sortText: '', sortOrderType: ''}, () => {
			this.fetchAceAlerts();
		})
	}

	fetchAceAlerts = (pageNumber) => {
		const { searchText, sortText, sortOrderType } = this.state;
		
		this.props.fetch_alerts({
			page: pageNumber ? pageNumber : 0,
			search: searchText,
			sortKey: sortText,
			sortOrder: sortOrderType
		});
	}

	render() {
		const { sortText, sortOrderType } = this.state;
		let mainDisplay = <div className={"CorrectiveInfoText"}>Please upgrade to the SCADA Premium platform.</div>;
		if (true /*this.props.dandoEnabled*/) {
			mainDisplay = <React.Fragment>
				<AceSelector
					aceAlerts={this.props.aceAlerts.acealerts_in_current_page}
					onDandOClick={this.onAceAlertSelect}
					firmSettings={this.props.firmSettings}
					handleSearch={this.handleSearch}
					handleClear={this.handleClear}
					handleSort={this.handleSort}
					sortValue={sortText}
					sortOrder={sortOrderType}
				/>
				<Paginator
					name={"ace-selector"}
					totalPages={this.props.totalPages}
					currentPage={this.props.currentPage}
					setPage={(pageNumber) => this.fetchAceAlerts(pageNumber, sortText, sortOrderType)} />

					{this.state.openBlock && <Modal
			open={this.state.openBlock}
			onClose={this.onCloseBlockModal}
			focusTrapped={true}
			styles={{ modal: {width: "60%", height: "60%", overflow: "auto" } }}
		>
			<div className="ModalWindow modaladd">
				<FaTimes className="closeicon" onClick={this.onCloseBlockModal} />
				<br />
				<div className="modalHeading"></div>
				<div className="NavDivider"></div>
				<Disclosure />
				<div className="NavDivider"></div>
				<div>
					<div className="NavDivider"></div>
					<ButtonHolder>
						<LeftSideButton
							onClick={evt => {
								window.open(
												"https://www.sarlit.com/contact-us", "_blank");
							}}
							hoverBorderColor="#83bed3"
							tabIndex="-1"
						>
							License Risk Report
						</LeftSideButton>
					</ButtonHolder>

				</div>
			</div>
		</Modal>}
			</React.Fragment>
		}

		return (
			<React.Fragment>
				{mainDisplay}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		aceAlerts: state.aceAlerts,
		currentPage: state.aceAlerts.current_page,
		totalPages: state.aceAlerts.total_pages,
		firmSettings: state.firmSettings,
		dandoEnabled: true //state.firmSettings.dandoEnabled
	}
};

const mapDispatchToProps = dispatch => {
	return {
		fetch_alerts: (input) => dispatch(fetch_alerts(input)),
		select_dando: (dando_id) => dispatch(select_dando(dando_id)),
		send_email:(alertData)=>dispatch(send_email(alertData))		
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(AceSelectorContainer);


// WEBPACK FOOTER //
// ./src/ace/components/AceSelectorContainer.js